
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Typography, Avatar, useMediaQuery, Box, alpha } from '@mui/material';
import { useTheme } from '@emotion/react';
import { iconos } from '../../data';
import { useAuthStore, useSidebarStore } from '../../store';

import { envVariables } from '../../helpers/getEnvVariables';
const url = Number( envVariables.REACT_APP_API_URL);






export const SideBarScreen = () => {

    const navigate = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery('(max-width: 600px)');
    const { usuario, menuData } = useAuthStore();
    const isSidebarOpen = useSidebarStore( state => state.isSidebarOpen );
    const sidebarCerrado = useSidebarStore( state => state.sidebarCerrado );

    const [subMenu, setsubMenu] = useState(null);
    const [rutas, setRutas] = useState(null);
    const [menu, setMenu] = useState(null);

    

    useEffect(() => {
        if (matches) { sidebarCerrado() }
    }, [matches]);



    const handleClick = (valor) => {
        const { text, ruta } = valor;
        setsubMenu(subMenu === text ? null : text);
        if( ruta ){
            navigate(`${ruta}`)
        }
    };



    const handleArrowMenu = (valor) => {
        if( menu === valor ){
        setMenu(null)
        }else {
        setMenu(valor);
        }
    };



    const handleSubMenu = (menu) => {
        setRutas( menu );
        navigate(`${ menu }`);
    }



    return (

        // <Drawer variant="persistent" anchor="left" open={isSidebarOpen}
        //     sx={{ flexShrink: 0, '& .MuiDrawer-paper': {boxSizing: 'border-box', borderRight: 'none',
        //         boxShadow: '0px 10px 30px -5px rgba(0, 0, 0, 0.1)', background: theme.palette.background.paper,},
        // }}>
        //     <Box sx={{background: `linear-gradient(145deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`, py: 4, display: 'flex', flexDirection: 'column', 
        //         alignItems: 'center', position: 'relative', overflow: 'hidden',
        //         '&::before': { content: '""', position: 'absolute', width: '200%',
        //         height: '200%', top: '-50%', left: '-50%',
        //     }}}>
        //         <Avatar src={`${url}/uploads/usuarios/${'xxxxx'}`}
        //             sx={{ width:90, height:90, border:`3px solid ${theme.palette.common.white}`,
        //                 boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', transition: 'transform 0.3s',
        //                 '&:hover': {transform: 'scale(1.05)',}
        //         }}/>
        //         <Typography variant="h5" sx={{mt:2, fontWeight:600, color:theme.palette.common.white, 
        //             overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', width:'80%', textAlign:'center',
                    
        //         }}>
        //             {usuario.nombre}
        //         </Typography>

        //         <Box sx={{ mt:1, px:2.5, py:0.5, backgroundColor:alpha(theme.palette.common.white, 0.2),
        //             borderRadius: 5, backdropFilter: 'blur(4px)',
        //         }}>
        //             <Typography variant="body2" sx={{ color: theme.palette.common.white, fontSize: '0.75rem', 
        //                 fontWeight: 500, letterSpacing: 0.5,
        //             }}>
        //                 {usuario.role}
        //             </Typography>
        //         </Box>
        //     </Box>

        //     <Box sx={{ mt: 2, px: 2 }}>
        //         <Typography variant="overline" sx={{ color: theme.palette.text.secondary,
        //             fontWeight: 600, fontSize: '0.75rem', letterSpacing: 1,
        //         }}>
        //             GENERAL
        //         </Typography>
        //     </Box>

        //     <List sx={{ px: 2, pt: 1 }}>
        //         {menuData?.map((item) => (
        //         <Box key={item.text} sx={{ mb: 0.5 }}>
        //             <ListItem disablePadding sx={{  borderRadius:1.5, overflow:'hidden', mb:0.5,
        //                 '&:hover': {backgroundColor: alpha(theme.palette.primary.main, 0.08)},
        //             }}>
        //                 <ListItemButton  onClick={() => { handleClick(item); handleArrowMenu(item.text);}}
        //                     sx={{borderRadius:1.5, py:1,
        //                     backgroundColor: menu === item.text ? alpha(theme.palette.primary.main, 0.1) : '',
        //                 }}>
        //                     <ListItemIcon sx={{ minWidth: 40, color: menu === item.text ? theme.palette.primary.main : ''}}>
        //                         {iconos[item.icon]}
        //                     </ListItemIcon>

        //                     <ListItemText primary={
        //                         <Typography variant="body1" 
        //                             sx={{ fontWeight: menu === item.text ? 600 : 500,
        //                             color: menu === item.text ? theme.palette.primary.main : theme.palette.text.primary,
        //                             transition: 'all 0.2s'
        //                         }}>
        //                             {item.text}
        //                         </Typography>
        //                     }/>

        //                     {item.submenus && ( 
        //                         menu === item.text ? (
        //                         <ExpandMore sx={{ color:theme.palette.primary.main, transition:'transform 0.3s'}} />
        //                     ) : (
        //                         <KeyboardArrowRight sx={{color:theme.palette.text.secondary, transition:'transform 0.3s'}} />
        //                     ))}
        //                 </ListItemButton>
        //             </ListItem>

        //             {item.submenus && (
        //             <Collapse in={subMenu === item.text} timeout="auto" unmountOnExit>
        //                 <Box sx={{ml:2, pl:2, py:0.5, borderLeft: `2px dashed ${theme.palette.primary.main}`}}>
        //                 <List component="div" disablePadding>
        //                     {item.submenus.map((submenu) => (
        //                     <ListItemButton key={submenu.subtitle}
        //                         onClick={() => handleSubMenu(submenu.ruta)}
        //                         sx={{py:0.8, px:2, mt:0.5, borderRadius:1.5, position:'relative',
        //                         backgroundColor: rutas === submenu.ruta 
        //                             ? alpha(theme.palette.secondary.main, 0.12) 
        //                             : alpha(theme.palette.background.default, 0.7),
        //                         border: `1px solid ${rutas === submenu.ruta 
        //                             ? alpha(theme.palette.secondary.main, 0.3) 
        //                             : alpha(theme.palette.divider, 0.1)}`,
        //                         boxShadow: rutas === submenu.ruta 
        //                             ? `0 2px 6px ${alpha(theme.palette.secondary.main, 0.15)}` 
        //                             : 'none',
        //                         '&:hover': {
        //                             backgroundColor: rutas !== submenu.ruta && alpha(theme.palette.secondary.main, 0.05),
        //                         },
        //                         transition: 'all 0.2s',
        //                         '&::before': rutas === submenu.ruta ? {
        //                             content: '""',
        //                             position: 'absolute',
        //                             left: -12,
        //                             top: '50%',
        //                             width: 12,
        //                             height: 2,
        //                             backgroundColor: theme.palette.secondary.main,
        //                             transform: 'translateY(-50%)',
        //                         } : {},
        //                         }}
        //                     >
        //                         <ListItemText primary={
        //                             <Typography variant="body2"
        //                             sx={{ fontWeight: rutas === submenu.ruta ? 600 : 400, transition: 'all 0.2s',
        //                                 color: rutas === submenu.ruta ? theme.palette.secondary.main : '',
        //                             }}>
        //                                 {submenu.subtitle}
        //                             </Typography>
        //                         }/>
        //                         {rutas === submenu.ruta && (
        //                         <Box sx={{width:6, height:6, borderRadius:'50%', ml:1,
        //                             bgcolor: theme.palette.secondary.main,
        //                         }}/>
        //                         )}
        //                     </ListItemButton>
        //                     ))}
        //                 </List>
        //                 </Box>
        //             </Collapse>
        //             )}
        //         </Box>
        //         ))}
        //     </List>
        // </Drawer>


        <Drawer variant="persistent" anchor="left" open={isSidebarOpen}
            sx={{flexShrink:0, '& .MuiDrawer-paper':{boxSizing:'border-box', borderRight:'none', background:'#262626'}
        }}>

            <Box sx={{background: '#262626', borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.5)}`,
                py:4, display:'flex', flexDirection:'column', alignItems:'center', position:'relative', overflow:'hidden',
                '&::before': {content:'""', position:'absolute', width:'200%', height:'200%', top:'-50%', left:'-50%'}
            }}>
                <Avatar src={`${url}/uploads/usuarios/${usuario?.img ?? 'xxxxx'}`}
                    sx={{ width:100, height:100, transition: 'transform 0.3s', border: `3px solid white`,
                    '&:hover': { transform: 'scale(1.05)'}
                }}/>
                <Typography variant="h5" sx={{mt:2, fontWeight:600, color:'white', overflow:'hidden', 
                    textOverflow:'ellipsis', whiteSpace:'nowrap', width:'85%', textAlign: 'center',
                }}>
                    {usuario?.nombre}
                </Typography>

                <Box sx={{mt:0.2, px:2.5, py:0.5, borderRadius:5, backdropFilter:'blur(4px)',
                    backgroundColor: alpha(theme.palette.common.white, 0.2),
                }}>
                    <Typography variant="body2" sx={{color:'white', fontSize:'0.75rem', fontWeight:500, letterSpacing:0.5}}>
                        {usuario.role}
                    </Typography>
                </Box>
            </Box>

            {/* Menu List */}
            <List sx={{px:1.5, pt:1, overflowX: 'auto', flex:1, pb:3,
                '&::-webkit-scrollbar': {width: '8px'},
                '&::-webkit-scrollbar-track': {backgroundColor: '#1a1a1a'},
                '&::-webkit-scrollbar-thumb': {backgroundColor: '#4a4a4a', borderRadius: '10px'},
                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#5a5a5a'},
                scrollbarWidth: 'thin', scrollbarColor: '#4a4a4a #1a1a1a', 
            }}>
                <Box sx={{mt:2}}>
                    <Typography variant="overline" sx={{color:'gray', fontWeight:600, fontSize:'0.75rem', letterSpacing:1}}>
                        GENERAL
                    </Typography>
                </Box>  
                {menuData?.map((item) => (
                <Box key={item.text} sx={{mb:0.5}}>
                    <ListItem disablePadding sx={{ borderRadius:1.5, overflow:'hidden', mb: 0.5,
                        '&:hover': {backgroundColor: alpha(theme.palette.primary.main, 0.08)}
                    }}>
                        <ListItemButton onClick={() => { handleClick(item); handleArrowMenu(item.text) }}
                            sx={{ borderRadius:1.5, py:1, backgroundColor: menu === item.text 
                            ? alpha(theme.palette.primary.main, 0.1) : '',
                        }}>
                            <ListItemIcon sx={{minWidth: 40, color: menu === item.text ? theme.palette.primary.main : 'white'}}>
                            {iconos[item.icon]}
                            </ListItemIcon>

                            <ListItemText primary={
                            <Typography variant="body1" sx={{ transition:'all 0.2s', fontWeight: menu === item.text ? 600 : 500,
                                color: menu === item.text ? theme.palette.primary.main : 'white',
                            }}>
                                {item.text}
                            </Typography>
                            }/>


                            {item.submenus && (
                            menu === item.text
                            ? React.cloneElement(iconos['expandir'], {style:{ color: theme.palette.primary.main, transition: 'transform 0.3s' } })
                            : React.cloneElement(iconos['derecha'], {style:{color: theme.palette.text.secondary, transition: 'transform 0.3s'} }) 
                            )}
                        </ListItemButton>
                        </ListItem>

                        {item.submenus && (
                        <Collapse in={subMenu === item.text} timeout="auto">
                        <Box sx={{ml:2, pl:2, py:0.5, borderLeft:`2px dashed ${theme.palette.primary.main}`}}>
                            <List component="div" disablePadding>
                            {item.submenus.map((submenu) => (
                                <ListItemButton key={submenu.subtitle}
                                onClick={() => handleSubMenu(submenu.ruta)}
                                sx={{
                                    py: 0.8, 
                                    px: 2, 
                                    mt: 0.5, 
                                    borderRadius: 1.5, 
                                    position: 'relative',
                                    backgroundColor: rutas === submenu.ruta 
                                    ? alpha(theme.palette.secondary.main, 0.12) : '',
                                    // border: `1px solid ${rutas === submenu.ruta 
                                    //   ? alpha(theme.palette.secondary.main, 0.3) 
                                    //   : 'transparent'}`,
                                    '&:hover': {
                                    backgroundColor: rutas === submenu.ruta 
                                        ? alpha(theme.palette.secondary.main, 0.12) 
                                        : alpha(theme.palette.secondary.main, 0.2)
                                    },
                                    transition: 'all 0.2s',
                                    '&::before': rutas === submenu.ruta ? {
                                    content: '""',
                                    position: 'absolute',
                                    left: -12,
                                    top: '50%',
                                    width: 12,
                                    height: 2,
                                    backgroundColor: theme.palette.secondary.main,
                                    transform: 'translateY(-50%)',
                                    } : {},
                                }}
                                >
                                <ListItemText primary={
                                    <Typography variant="body2" sx={{fontWeight: rutas === submenu.ruta ? 600 : 400, 
                                    transition:'all 0.2s', color:rutas === submenu.ruta ? theme.palette.secondary.main : 'white',
                                    }}>
                                    {submenu.subtitle}
                                    </Typography>
                                }/>

                                {rutas === submenu.ruta && (
                                    <Box sx={{width:6, height:6, borderRadius:'50%', ml:1, bgcolor:theme.palette.secondary.main}}/>
                                )}
                                </ListItemButton>
                            ))}
                            </List>
                        </Box>
                        </Collapse>
                    )}
                </Box>
                ))}
            </List>
        </Drawer>

    );
}





// const isMobileDevice = useMediaQuery(theme.breakpoints.down('md'));
    // // // Reset sidebar state on mobile/desktop switch
    // // useEffect(() => {
    // //     if (isMobileDevice) {
    // //     setIsSidebarOpen(false);
    // //     } else {
    // //     setIsSidebarOpen(true);
    // //     }
    // // }, [isMobileDevice]);

    // // console.log(theme.palette.primary); 
// <Drawer variant="persistent" anchor="left" open={ isSidebarOpen } >

            //     <DrawerHeader sx={{width:'100%', background:'white', minHeight:'150px', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center'}}>
            //         <Grid item sx={{ mt:3 }}>
            //             <Avatar src={`${url}/uploads/usuarios/${'xxxxx'}`} sx={{ width:'80px', height:'80px', 
            //                 border: `2px solid primary.main`
            //             }} />
            //         </Grid>
            //         <Grid item sx={{mb:2, mt:0.7}}>
            //             <Typography variant="h5"
            //                 sx={{ mt: 2, fontWeight: 600, color: 'black', overflow: 'hidden', textOverflow: 'ellipsis',
            //                     whiteSpace: 'nowrap', width: '90%', textAlign: 'center', display: 'inline-block', 
            //             }}>
            //                 {usuario.nombre}
            //             </Typography>
            //             <Typography variant="body2" sx={{ color: theme.palette.text.secondary,   borderRadius: 5, 
            //                 color: 'white', px:2, py:0.5, bgcolor: 'primary.main', fontSize: '0.75rem',
            //                 width:'50%', textAlign: 'center', display: 'inline-block'
            //             }}>
            //                 { usuario.role }
            //             </Typography>
            //         </Grid>
            //     </DrawerHeader>
            //     <Divider sx={{backgroundColor:"gray", mx:2}} />


            //     <List sx={{background:'white', overflowX:'auto', flex:1, pb:3}}>
            //     <ListSubheader sx={{mt:2, background:'white', color:'black'}} disableSticky>GENERAL</ListSubheader>
            //     {menuData?.map( (item) => (
            //         <div key={ item.text }>
            //         <ListItem disablePadding>
            //             <ListItemButton onClick={ () => {
            //                 handleClick(item);
            //                 handleArrowMenu(item.text)
            //             }}>
            //             <ListItemIcon sx={{color:'black'}}>{iconos[item.icon]}</ListItemIcon>
            //             <ListItemText
            //                 primary={
            //                 <Typography sx={{ml:-2, color:'black'}} variant="h5">{item.text}</Typography>
            //                 }
            //             />
            //             {(item.submenus) &&
            //                 <>
            //                 {(menu === item.text) 
            //                 ? <ExpandMore sx={{color:'black'}}/> 
            //                 : <KeyboardArrowRight sx={{color:'black'}}/>
            //                 }
            //                 </>
            //             }
            //             </ListItemButton>
            //         </ListItem>

            //         {(item.submenus) &&
            //         <Collapse in={subMenu === item.text} timeout="auto" unmountOnExit>
            //             <List component="div" disablePadding>
            //             {item.submenus.map( (submenu) => (
            //                 <ListItemButton className='lista-drawer' key={submenu.subtitle} 
            //                     onClick={ () => handleSubMenu(submenu.ruta)}
            //                 >
            //                 <ListItemText sx={{ml:4}} primary={ 
            //                     <Typography variant="h5" sx={{ color:(rutas === submenu.ruta) ? 'secondary.main' : 'black' }}>
            //                         {submenu.subtitle}
            //                     </Typography> }
            //                 />
            //                 </ListItemButton>
            //             ))}
            //             </List>
            //         </Collapse>
            //         }
            //         </div>
            //     ))}
            //     </List>

            // </Drawer>

// 









